<template>
  <div class="create-team-container">
    <div class="create-team-box">
      <el-form
        ref="teamForm"
        v-loading="saveLoading"
        :model="teamForm"
        :rules="teamRules"
        :disabled="saveLoading"
        class="create-team-form"
        label-width="var(--team-entry-label-width, 120px)"
        @submit.prevent="createTeam"
      >
        <el-form-item
          :label="$t('views.user_center.team_name')"
          prop="name"
        >
          <el-input
            v-model="teamForm.name"
            maxlength="100"
            autocomplete="organization"
            @input="formError = ''"
            :placeholder="$t('views.user_center.enter_team_name')"
          />
        </el-form-item>
<!--        <el-form-item
          :label="$t('views.user_center.industry')"
          prop="industry_id"
        >
          <el-cascader
            v-model="teamForm.industry_id"
            style="width: 100%"
            :options="industryOption"
            :props="industryOptionProps"

            @change="industryChange"
          />
        </el-form-item>
        <el-form-item
          :label="$t('views.user_center.company_size')"
          prop="scale"
        >
          <el-select
            v-model="teamForm.scale"
            class="team-scale"
            :placeholder="$t('views.user_center.select_company_size')"
          >
            <el-option
              v-for="item in scaleOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>-->
      </el-form>
      <el-alert v-if="formError" class="team-form-error" :title="formError" type="error" :closable="false" show-icon />
    </div>

  </div>
</template>

<script>
import { getTreeIndustry } from '@/api/dict'
import { createTeam } from '@/api/team'

export default {
  name: 'CreateTeam',
  components: {},
  emits: ['update-team', 'busy-change'],
  props: {
    isDialog: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      teamForm: {
        name: '',
        industry_id: '',
        scale: ''
      },
      teamRules: {
        name: [
          { required: true, message: this.$t('views.user_center.enter_team_name'), trigger: 'blur' },
          { min: 3, max: 100, message: this.$t('views.user_center.team_name_length'), trigger: 'blur' }
        ],
/*        industry_id: [
          { required: true, message: this.$t('views.user_center.industry_required'), trigger: 'blur' }
        ],
        scale: [
          { required: true, message: this.$t('views.user_center.size_required'), trigger: 'blur' }
        ]*/
      },
      scaleOption: [
        { label: this.$t('views.user_center.size_1_10'), value: '1~10人' },
        { label: this.$t('views.user_center.size_11_50'), value: '11~50人' },
        { label: this.$t('views.user_center.size_51_100'), value: '51~100人' },
        { label: this.$t('views.user_center.size_101_300'), value: '101~300人' },
        { label: this.$t('views.user_center.size_301_1000'), value: '301~1000人' },
        { label: this.$t('views.user_center.size_1001_plus'), value: '1001人及以上' }
      ],
      industryOption: [],
      industryOptionProps: {
        expandTrigger: 'hover',
        label: 'name',
        value: 'id'
      },
      saveLoading: false,
      formError: '',
      requestSerial: 0,
      disposed: false
    }
  },
  computed: {
    businessContext() {
      return `${this.$store.getters.user_id || ''}:${this.$store.getters.current_team_id || ''}`
    }
  },
  watch: {
    saveLoading(value) {
      this.$emit('busy-change', value)
    },
    businessContext() {
      this.requestSerial += 1
      this.saveLoading = false
      this.formError = ''
    }
  },
  mounted() {
    this.getIndustry()
  },
  beforeUnmount() {
    this.disposed = true
    this.requestSerial += 1
    this.$emit('busy-change', false)
  },
  methods: {
    industryChange() {

    },
    async createTeam() {
      if (this.saveLoading || this.disposed || !this.$refs.teamForm) return
      const serial = ++this.requestSerial
      const context = this.businessContext
      const isCurrent = () => !this.disposed && serial === this.requestSerial && context === this.businessContext
      this.formError = ''
      this.saveLoading = true
      try {
        const valid = await this.$refs.teamForm.validate().catch(() => false)
        if (!valid || !isCurrent()) return
        const params = {
          name: this.teamForm.name,
          industry_id: this.teamForm.industry_id[this.teamForm.industry_id.length - 1],
          scale: 0
        }
        const response = await createTeam(params)
        if (!isCurrent()) return
        if (!response || ![0, 200].includes(Number(response.code))) {
          this.formError = this.$t('common.operation_failed')
          return
        }
        if (this.isDialog) {
          this.$message.success(this.$t('views.user_center.team_created'))
          this.$emit('update-team', response.data)
        }
      } catch (error) {
        if (isCurrent()) this.formError = error && error.message ? error.message : this.$t('common.operation_failed')
      } finally {
        if (isCurrent()) this.saveLoading = false
      }
    },
    initCreateTeam() {
      this.requestSerial += 1
      this.saveLoading = false
      this.formError = ''
      this.teamForm.name = ''
      this.teamForm.industry_id = ''
      this.teamForm.scale = ''
    },
    getIndustry() {
      getTreeIndustry({}).then(response => {
        if (!this.disposed && response && response.code === 0) {
          this.industryOption = response.data
        }
      }).catch(() => {

      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/views/user_center/components/create_team";
@import "@/views/mobile/user_center/styles/team_forms";
</style>
